module.exports = __webpack_public_path__ + "img/steel-furnace.dcca91d7.png";